<template>
  <div>
    <v-data-table class="elevation-1 tbl"
                  dense
                  :value="selectedRows"
                  @input="$emit('update:selectedRows', $event)" show-select
                  :loading="loading"
                  :headers="headers"
                  :items="leadsList"
                  :items-per-page="-1"
                  search-field="name"
                  item-key="id"
                  :custom-sort="customSort"
                  hide-default-footer>

      <template #item="{item, isSelected, select}">
        <tr
            :class="{ 'v-data-table__selected': isSelected }"
            @click.ctrl="toLead(item, true)"
            @click.meta="toLead(item, true)"
            @click.exact="toLead(item)">
          <td>
            <v-simple-checkbox
                :value="isSelected"
                @input="select"
            />
          </td>
          <td v-if="getHeader('site')">
            <div class="d-flex flex-column">
              <span class="caption grey--text text-lighten-2">#{{ item.id }}</span>
              <site-label :sitename="item.virtualSite"/>
            </div>
          </td>
          <td v-if="getHeader('source')">
            <div class="">
              <v-chip small label :color="sourceColor(item)" text-color="white" class="mr-3">{{
                  $t('lead.source.' + item.source)
                }}
              </v-chip>
            </div>
          </td>

          <td v-if="getHeader('score')" colspan="0.7%">
            <div class="d-flex flex-column">
              <score-lead :score="item.score"/>
            </div>
          </td>

          <td v-if="getHeader('customer')">
            <div class="d-flex flex-column">
              <div class="body-2 d-flex flex-column" v-if="item.customer">
                <span>{{ item.customer.name }} </span>
                <span>
                  <span class="caption grey--text text--darken-1">{{ item.customer.email }}</span> <span
                    class="caption grey--text " v-if="item.customer.phone"> | {{ item.customer.phone }}</span>

              </span>

              </div>
              <span class="body-2" v-else>-</span>

            </div>
          </td>

          <td v-if="getHeader('user')">
            <div class="d-flex flex-column" v-if="item.user?.name">
              {{ item.user.name }}
            </div>
          </td>

          <td v-if="getHeader('creationDate')">
            <div class="d-flex flex-column">
              <span>{{
                  _parseAndFormatDate(item.creationDate, datePatternConfig.serverLocalDateTime, "dd/MM/yyyy")
                }}</span>
              <span class="caption grey--text ">{{
                  _parseAndFormatDate(item.creationDate, datePatternConfig.serverLocalDateTime, "HH'h'mm")
                }}</span>
            </div>
          </td>
          <td v-if="getHeader('earlierStartdate')">
            <div class="d-flex flex-column" v-if="item.earlierStartdate && item.quotes > 0">
              <span>{{
                  _parseAndFormatDate(item.earlierStartdate, datePatternConfig.serverLocalDateTime, "dd/MM/yyyy")
                }}</span>
              <span class="caption grey--text ">{{
                  _parseAndFormatDate(item.earlierStartdate, datePatternConfig.serverLocalDateTime, "HH'h'mm")
                }}</span>
            </div>
            <span v-else>-</span>
          </td>


          <td v-if="getHeader('quotes')">
            <div class="d-flex justify-start caption">
              {{ item.quotes }}
            </div>
          </td>
          <td v-if="getHeader('destinations')">
            <div class="d-flex justify-start body-2">
              {{ item.destinations.join(", ") || "-" }}
            </div>
          </td>
          <td v-if="getHeader('budget')">
            {{ item.budget |currency('EUR') }}
          </td>

          <td v-if="getHeader('relance')">
            <div class=" caption ml-6" v-if="item.nbRelance > 0"
                 :class="needRelance(item) ? 'font-weight-bold' : ''">
              {{ `${item.nbRelance}` }}
            </div>
            <div v-else class="ml-6">-</div>
          </td>
          <td v-if="getHeader('lastActionDate')">
            <div class=" caption d-flex flex-column" v-if="item.lastActionType"
                 :class="needRelance(item) ? 'font-weight-bold' : ''">

              <v-chip small label outlined class="mt-1" :class="sinceDays(item) <= 3 ? '':'orange'"
                      :textColor="sinceDays(item) <= 3 ? 'grey':'orange'" style="max-width:fit-content">
              <span>{{
                  $t("lead.action." + item.lastActionType)
                }}</span>
              </v-chip>
              <span class="grey--text lighten-1 caption"
                    v-if="item.lastActionDate">le {{
                  _parseAndFormatDate(item.lastActionDate, "dd/MM/yyyy HH:mm:ss", "EEEE dd")
                }} il y a {{ sinceDays(item) }} jours
              </span>
              <span class="grey--text lighten-1"
                    v-if="item.lastActionDate">
              </span>
            </div>
            <div v-else>-</div>
          </td>

          <td v-if="getHeader('status')">
            <div class="">
              <v-chip :text-color="colorTag(item)" small label outlined
                      :color="colorTag(item)">{{
                  item.status == 'close' && item.converted ? "Converti" : $t('lead.status.' + item.status)
                }}
              </v-chip>
            </div>
          </td>
        </tr>
      </template>

    </v-data-table>
  </div>
</template>
<script>
import ScoreLead from "@/components/booking/ScoreLead.vue";
import SiteLabel from "@/components/commons/SiteLabel.vue";
import FormMixin from "@/components/mixins/FormMixin";
import {EventBus} from "@/components/commons/event-bus";
import {subDays} from "date-fns";

export default {
  components: {
    ScoreLead,
    SiteLabel,
  },
  mixins: [FormMixin],
  props: {
    leadsList: {
      type: Array,
      required: true,
    },
    selectedRows: {
      type: Array,
      required: true,
    },
  },
  data(self) {
    return {
      loading: false,
      newLeadModal: false,
      headers: [
        {
          text: "Site",
          value: "site",
          align: "left",
          width: '5%',
          sortable: false,
        },
        {
          text: "source",
          value: "source",
          align: "left",
          sortable: true,
          width: 90,
        },
        {
          text: "Score",
          value: "score",
          align: "left",
          width: '5%',
          sortable: true,
        },
        {
          text: "Client",
          value: "customer",
          align: "left",
          width: '15%',
          sortable: true,
        },
        {
          text: "Utilisateur",
          value: "user",
          align: "left",
          width: '10%',
          sortable: true,
        },
        {
          text: "Création",
          value: "creationDate",
          align: "left",
          sortable: true,
        },
        {
          text: "Départ",
          value: "earlierStartdate",
          align: "left",
          sortable: true,
        },
        {
          text: "Devis",
          value: "quotes",
          align: "left",
          sortable: true,
        },
        {
          text: "Destinations",
          value: "destinations",
          align: "left",
          sortable: false,
          width: '10%',
        }
        ,
        {
          text: "Budget",
          value: "budget",
          align: "left",
          sortable: true,
        },
        {
          text: "Relances",
          value: "relance",
          align: "",
          sortable: true,
          width: 110
        },
        {
          text: "Dernière action",
          value: "lastActionDate",
          align: "left",
          sortable: true,
        },
        {
          text: "status",
          value: "status",
          align: "right",
          sortable: true,
          width: 90,
        },
      ]
    }
  },
  destroyed() {
    EventBus.$off("reloadListLead");
  },
  methods: {
    sinceDays(item) {
      return this._duration(this._parseDate(item.lastActionDate, "dd/MM/yyyy HH:mm:ss"), new Date(), 'days')
    },
    getHeader(value) {
      return this.headers.find((x) => x.value === value) != null;
    },
    toLead(lead, newTab) {
      if (newTab) {
        let route = this.$router.resolve({
          name: "lead",
          params: {id: lead.id},
        });
        window.open(route.href, "_blank");

      } else {
        this.$router.push({name: "lead", params: {id: lead.id}});
      }
    },
    needRelance(item) {
      if (item.lastActionType === "relance") {
        const lastActionDateObj = this._parseDate(item.lastActionDate, "dd/MM/yyyy hh:mm:ss")
        return this._isSameOrBefore(lastActionDateObj, subDays(new Date(), 3))
      } else return false
    },
    sortByDateTime(a, b) {
      return this._sortDates(a, b, this.datePatternConfig.serverLocalDateTime);
    },
    customSort(items, sortBy, sortDesc) {
      const column = sortBy[0]
      const isDesc = sortDesc[0]
      const header = this.headers.find(h => h.value == column)

      if (column == 'lastActionDate' || column == 'creationDate' || column == 'earlierStartdate') {
        return items.sort((a, b) => {
          let dateA = a[column]
          let dateB = b[column]

          if(column == 'earlierStartdate'){
            if(a.quotes == 0) dateA = null
            if(b.quotes == 0) dateB = null
          }

          if (dateA === null && dateB === null) return 0
          if (dateA === null) return 1
          if (dateB === null) return -1
          return isDesc ?
              this._sortDates(dateB, dateA, this.datePatternConfig.serverLocalDateTime) :
              this._sortDates(dateA, dateB, this.datePatternConfig.serverLocalDateTime)
        })
      } else if (column == 'customer' || column == 'user') {
        return items.sort((x, y) => {
          if (x[column] === null) return isDesc ? 1 : -1
          if (y[column] === null) return isDesc ? -1 : 1

          if (!x[column].name && y[column].name) {
            return 1
          } else if (x[column].name && !y[column].name) {
            return -1
          }

          return isDesc ? y[column].name.localeCompare(x[column].name) : x[column].name.localeCompare(y[column].name)
        })
      } else if(column == 'status' || column == 'source') {
        return items.sort((a, b) => {
          return isDesc ? b[column].localeCompare(a[column]) : a[column].localeCompare(b[column])
        })
      }else if (column == 'relance') {
        return items.sort((a, b) => {
          return isDesc ? b.nbRelance - a.nbRelance : a.nbRelance - b.nbRelance
        })
      } else if (header != null && header.sortable) {
        return items.sort((a, b) => {
          return isDesc ? b[column] - a[column] : a[column] - b[column]
        })
      } else return items
    },
    sourceColor(item) {
      switch (item.source) {
        case 'phone':
          return "green";
        case 'form':
          return "#095464";
        case 'email':
          return "purple lighten-2";
        case 'quotation':
          return "green";
        case 'option':
          return 'orange lighten-1';
        case 'payment':
          return 'red';
        default: //backoffice
          return 'blue'
      }
    },
    colorTag(item) {
      return item.status == 'open' || (item.status == 'close' && item.converted)
          ? 'green'
          :
          item.status == 'close'
              ? 'red'
              : 'orange'
    },
    getIcon(action) {
      switch (action) {
        case 'update':
          return "mdi-update";
        case 'call':
          return "mdi-phone";
        case 'email':
          return "mdi-mail";
        case 'proposition':
          return "mdi-currency-eur";
      }
    },
  }

}
</script>